import { data, find, findAll } from './dom';

// Primer na zidu bez JavaScript-a otvara samu sliku; ovde se ista slika uvećava preko stranice, a dodir bilo gde zatvara.
export function enhanceLightbox(): void {
  const dialog = document.querySelector('[data-js="lightbox"]');
  if (!(dialog instanceof HTMLDialogElement)) return;

  const frame = find(dialog, 'lightbox-frame', HTMLElement);
  const caption = find(dialog, 'lightbox-caption', HTMLElement);

  findAll(document, 'lightbox-open', HTMLAnchorElement).forEach(link =>
    $(link).on('click', event => {
      event.preventDefault();
      const image = new Image();
      image.className = 'lightbox__image';
      image.alt = link.querySelector('img')?.alt ?? '';
      image.src = link.href;
      frame.replaceChildren(image);
      caption.textContent = data(link, 'caption');
      dialog.showModal();
    })
  );

  $(dialog).on('click', () => dialog.close());
}
